<div class="heading-tab">
  <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> {{captureRole}}
    <a nz-tooltip [nzTooltipTitle]="_clientCount"><i nz-icon nzType="info-circle" nzTheme="outline"></i></a>
  </h3>
  <div>
    <!-- <button
      [disabled]="enableCopy && !(copySource && copySource.selectedClientData && copySource.selectedClientData.length == 0)"
      nz-button nzType="primary" (click)="EmitOpenSearchModal()">
      Search / Add {{captureRole}}
    </button> -->

    <button id="clientListButton" [disabled]="disabledButtonclientListExists || disableSearchAddButton" nz-button nzType="primary"
      (click)="EmitOpenSearchModal()">
      Search / Add {{captureRole}}
    </button>

  </div>

</div>
<div class="search-results m-t-20 m-b-20">
  <!-- *ngIf="clientList && clientList.length > 0" -->
  <nz-table *ngIf="clientList && clientList.selectedClientData && clientList.selectedClientData.length > 0"
    [nzShowPagination]="false" #SearchTable [nzData]="[1]">
    <thead>
      <tr>

        <th>Client Number</th>
        <th>Name</th>
        <th>Client Type</th>
        <th>Date Of Birth</th>
        <th>Gender</th>
        <th *ngIf="allowClientToBeCopied">Primary Insured</th>
        <th *ngIf="enableClientAsPayer">Payer</th>
        <th *ngIf="appMetadataHandler['LOB'] == 'LIFE' && (_captureRoleKey == 'PRIMARYINSURED' || _captureRoleKey == 'INSURED')">Relationship with Policy Proposer</th>
        <th *ngIf="_captureRoleKey == 'NOMINEE'">Nominee For</th>
        <th *ngIf="_captureRoleKey == 'APPOINTEE'">Appointee For</th>
        <th *ngIf="enableSplitPercentage">Split Percentage</th>
        <!-- <th *ngIf="addNominee">Nominee</th>
        <th *ngIf="addNominee">Relationship with Insured</th> -->
        <th>Actions</th>
      </tr>
    </thead>
    <tbody id="tableDetails">
      <ng-container *ngFor="let data of clientList?.selectedClientData; let i=index">
        <tr *ngIf="!clientList?.selectedClientData[i]['remove']">
          <td>{{data.clientNum}}</td>
          <td>{{(data?.titleCd | technicalTranslate) || ''}} {{data?.firstName || ''}} {{data?.lastName || ''}}
            {{data?.companyName || ''}}</td>
          <td>{{(data?.clientTypeCd | technicalTranslate) || 'Person'}}</td>
          <td>{{data.dateOfBirth | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</td>
          <td>{{(data.genderCd | technicalTranslate) || '-'}}</td>
          <!-- <td *ngIf="allowClientToCaptureRelationship"> -- </td> -->
          <td *ngIf="allowClientToBeCopied"><label nz-checkbox [(ngModel)]="data['isSelectedAsCopySource']"
              (ngModelChange)="onChangeIsCopySource(data,$event, 'PRIMARYINSURED')"></label></td>
          <!-- <td *ngIf="enableClientAsPayee"><label nz-checkbox [(ngModel)]="data['isPayee']"
              (ngModelChange)="onChangeIsPayee(data,clientList.fetchedClientData[i],$event)"></label></td>
          <td> -->
          <td *ngIf="enableClientAsPayer"><label nz-checkbox [(ngModel)]="data['isPayee']"
              (ngModelChange)="onChangeIsCopySource(data,$event, 'PAYER');onChangeIsPayee(data,clientList?.fetchedClientData[i],$event)"></label>
          </td>          
          <td *ngIf="appMetadataHandler['LOB'] == 'LIFE' && (_captureRoleKey == 'PRIMARYINSURED' || _captureRoleKey == 'INSURED')">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Relationship" [(ngModel)]="data['relationCd']" style="width:100%;" [nzDisabled]="data['relationCd'] == 'SELF'">
              <nz-option *ngFor="let item of (lookup$.relationCd | async) as relationCd; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
            </nz-option>
          </nz-select>
          </td>
          <td *ngIf="_captureRoleKey == 'NOMINEE'">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Insured" [(ngModel)]="data['nomineeForInsured']" style="width:100%;">
                <nz-option *ngFor="let item of (appMetadataHandler.insuredLookupForNominee['insuredCd']) as insuredCd; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
              </nz-option>
            </nz-select>
          </td>
          <td *ngIf="_captureRoleKey == 'APPOINTEE'">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Nominee" [(ngModel)]="data['appointeeForNominee']" style="width:100%;">
                <nz-option *ngFor="let item of (lookup$.nomineeForAppointeeCd | async) as nomineeForAppointeeCd; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
              </nz-option>
            </nz-select>
          </td>
          <td *ngIf="enableSplitPercentage">
            <nz-input-number [(ngModel)]="data.nomineeSplitPrct" [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [nzFormatter]="formatterPercent" [nzParser]="parserPercent"></nz-input-number>
          </td>
          <!-- <td *ngIf="addNominee">{{data.nominee || '-'}}</td>
          <td *ngIf="addNominee">{{data.relationshipWithInsured || '-'}}</td> -->
          <td>
            <!-- <ng-container
                                    *ngIf="copySource && copySource.selectedClientData && copySource.selectedClientData.length == 0"> -->
            <ng-container>
              <!-- <a class="mutates-data does-edit">Edit</a> | -->

              <a [class.isDisabled]="disabledButtonclientListExists || disableClientEdit"
                (click)="editClient(clientList?.fetchedClientData[i]) ;"> Edit
              </a> |

              <a [class.isDisabled]="disabledButtonclientListExists || disableClientRemove"
                *ngIf="!data['isExtractedFromPolicy']" nz-popconfirm nzPopconfirmTitle="Remove row?" nzOkText="Remove"
                nzCancelText="Cancel"
                (nzOnConfirm)="clientList?.selectedClientData[i]['remove'] = !clientList?.selectedClientData[i]['remove'];removeInsuredFromLookupCache(clientList)">Remove</a>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
  <app-generic-zero-ui [list]="clientList?.selectedClientData" icon="file-search" [title]="clientZeroState.title"
    [size]="'small'" [message]="clientZeroState.message"></app-generic-zero-ui>
</div>